import { IResLang } from 'api/services/langs/types';
import { Reducer } from 'redux';
import { ILangInitState, LangTypes } from './types';

const initState = {
	langs: undefined,
	currentLang: undefined,
};

const reducer: Reducer<ILangInitState> = (
	state = initState,
	{ type, payload },
) => {
	switch (type) {
		case LangTypes.GET_LANGS:
			return {
				...state,
				langs: payload.langs as IResLang[],
			};
		case LangTypes.CHANGE_LANG:
			return {
				...state,
				currentLang: payload.lang as IResLang,
			};
		default:
			return state;
	}
};

export default reducer;
